import React, { useState } from "react";
import "./styles.less";
import { ConsultModal } from "../../components/ConsultModal";
import { ConsultFormModal } from "../../components/CommonFormModal";

export const CommonConsult = (props) => {
  const { aside } = props;
  const [visible, setVisible] = useState(false);

  return (
    <div className="common-consult">
      <div
        onClick={() => {
          setVisible(true);
        }}
      >
        {aside}
      </div>
      <ConsultFormModal {...{ visible, setVisible }} />
      {/* <ConsultModal {...{ visible, setVisible }} /> */}
    </div>
  );
};
